'use strict';

//大熊
$(function () {
    $.getScript('//greatbearcst.sunlands.com/greatbear/assets/init.js?siteId=700118524', function () {
        $('.suggestBtn').click(function () {
            _GREATBEAR.show();
        });
        _GREATBEAR.siteId(700118524);
        _GREATBEAR.init({
            pvId: new Date().getTime(),
            uvId: ''
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./src/js/imStart.js
// module id = 60
// module chunks = 2 3 4 6 7 8 10 11 12